import {
  putRequestOTPLoginViaSms,
  RequestOTPResponse,
} from '@back-office/http';
import { FlowReturn } from 'mobx-state-tree/dist/core/flow';
import {
  LOCKED_USER_ERROR_MESSAGE,
  ResponseMessage,
  STATUS_CODE_NOT_AUTHORIZED,
  STATUS_CODE_NOT_FOUND,
} from '../../constants';
import { Self } from '../common';

function* requestOTPLoginViaSms(
  self: Self,
  email: string
): Generator<Promise<FlowReturn<RequestOTPResponse>>> {
  self.isLoading = true;
  self.isLoading = false;
  self.otp = { ...self.otp };
  try {
    const response = yield putRequestOTPLoginViaSms({
      email,
      otpId: self.otp.otpId,
      otpRef: self.otp.otpRef,
    });
    const { data, status } = (response as RequestOTPResponse).data;
    if (status.code === 1000) {
      const oldOtp = { authToken: self.otp.authToken, email: self.otp.email };
      self.otp.reset();
      self.otp = { ...self.otp, ...data, ...oldOtp };
      return Promise.resolve(ResponseMessage.OK);
    }
    if (status.code === STATUS_CODE_NOT_AUTHORIZED) {
      self.auth.reset();
      if (status.messages[0] === LOCKED_USER_ERROR_MESSAGE) {
        return Promise.resolve('login_form.user_locked');
      }
      return Promise.resolve('login_form.invalid_username_or_password');
    }

    if (status.code === STATUS_CODE_NOT_FOUND) {
      self.alert.title = 'login_form.not_applicable_sms_otp_title';
      self.alert.message = 'login_form.not_applicable_sms_otp';
      self.alert.open = true;
      return Promise.reject(new Error(ResponseMessage.Error));
    }

    self.alert.title = status.messages[0];
    self.alert.open = true;
    return Promise.reject(new Error(ResponseMessage.Error));
  } catch (e) {
    self.alert.title = 'login_form.internal_server_error';
    self.alert.open = true;
    return Promise.reject(new Error(e.message));
  } finally {
    self.isLoading = false;
  }
}

export default requestOTPLoginViaSms;
